export enum COOKIE_CONSENT {
	GRANTED = 'granted',
	DENIED = 'denied'
}